/* eslint-disable react/require-default-props */
import Box from '@material-ui/core/Box';
import * as React from 'react';

type BoxWithRefProps = React.ComponentPropsWithRef<typeof Box>;

export type CircleProps = Omit<
  BoxWithRefProps,
  'width' | 'height' | 'borderRadius' | 'children'
> & {
  size: number | string;
  color?: string;
  children?: React.ReactElement | string | number;
};

const toCssSize = (v: number | string) =>
  typeof v === 'number' ? `${v}px` : v;

const Circle = React.forwardRef<React.ElementRef<typeof Box>, CircleProps>(
  ({ size, color, style, children, ...rest }, ref) => {
    const cssSize = toCssSize(size);
    return (
      <Box
        borderRadius="50%"
        width={cssSize}
        height={cssSize}
        display="flex"
        alignItems="center"
        justifyContent="center"
        style={{
          padding: 5,
          boxSizing: 'border-box',
          backgroundColor: color,
          ...style,
        }}
        {...{ ...rest, ref }}
      >
        {children}
      </Box>
    );
  }
);

Circle.displayName = 'Circle';

export default Circle;
